import OpenAI from 'openai';
import axios from 'axios';
import api from '../api';
// const OPENAI_API_KEY = import.meta.env.VITE_OPENAI_API_KEY
// Initialize OpenAI with your API key from environment variables
// const openai = new OpenAI({
//   apiKey: OPENAI_API_KEY,
//   dangerouslyAllowBrowser: true,
// });


const aiService = {
  generateQuestions: async (data) => {
    console.log('DATA RECEIVED AT AISERVICE', data);
    try{
    const response = await api.post('/ai/generate-questions', data);
    console.log('AI questions response:', response.data);
    return response.data;
    } catch (error) {
      console.error('Error generating questions:', error);
      throw error;
    }
  },
  generateLessonNotes: async (data) => {
    try{
    const response = await api.post('/ai/generate-lesson-notes', data);
    return response.data;
    } catch (error) {
      console.error('Error generating questions:', error);
      throw error;
    }
  },

  askAssistant: async (data) => {
    try {
      const response = await api.post('/assistant', data);
      return response.data;
    } catch (error) {
      console.error('Error asking assistant:', error);
      throw error;
    }
  },
  completeQuestion: async (data) => {
    try {
      const response = await api.post('/ai/complete-question', data);
      return response.data;
    } catch (error) {
      console.error('Error completing question:', error);
      throw error;
    }
  },

};

export default aiService;

// Helper function to wait for run completion
// async function waitForRunComplete(threadId, runId) {
//     while (true) {
//         const runStatus = await openai.beta.threads.runs.retrieve(threadId, runId);
//         if (['completed', 'failed', 'requires_action'].includes(runStatus.status)) {
//             break; // Exit loop if run is completed, failed, or requires action
//         }
//         // Delay to avoid high-frequency polling
//         await new Promise((resolve) => setTimeout(resolve, 1000));
//     }
// }


